/**
 * PDP 悬浮加购条（PC）：挂到 document.body，与 Jivo 同层叠根，z-index 才能压住聊天按钮。
 * 悬浮条显示时切换 .yq-pdp-pc-jivo-lift-boost，配合 yq-global.css 上移 Jivo。
 * 手机端不 portal，避免离开 section 后移动端样式丢失。
 */
(function yqPdpFloatingBarJivoPc() {
  const BODY_CLASS = 'yq-pdp-pc-jivo-lift-boost';
  const FLOAT_SEL = 'product-quick-add.yq-pdp-floating-bar';
  const STICKY_HOST_SEL = 'product-rerender[id$="-sticky-bar"]';
  const mq = window.matchMedia('(min-width: 700px)');

  function isProductPage() {
    return document.body.classList.contains('page-type--product');
  }

  function portalFloatBar() {
    const el = document.querySelector(FLOAT_SEL);
    if (!el) return;

    const host = document.querySelector(STICKY_HOST_SEL);

    if (!mq.matches) {
      if (host && el.parentNode !== host) {
        host.appendChild(el);
      }
      return;
    }

    if (el.parentNode !== document.body) {
      document.body.appendChild(el);
    }
  }

  function syncBodyClass() {
    if (!isProductPage()) {
      document.body.classList.remove(BODY_CLASS);
      return;
    }
    const el = document.querySelector(FLOAT_SEL);
    const boost = mq.matches && el && el.classList.contains('is-visible');
    document.body.classList.toggle(BODY_CLASS, boost);
  }

  function bindFloat(el) {
    if (!el || el.dataset.yqJivoLiftBound === '1') return;
    el.dataset.yqJivoLiftBound = '1';
    const mo = new MutationObserver(() => {
      syncBodyClass();
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function findAndBind() {
    portalFloatBar();
    const el = document.querySelector(FLOAT_SEL);
    if (el) bindFloat(el);
    syncBodyClass();
  }

  function bindStickyHost(host) {
    if (!host || host.dataset.yqJivoLiftHostBound === '1') return;
    host.dataset.yqJivoLiftHostBound = '1';
    const mo = new MutationObserver(() => {
      document.querySelectorAll(`${FLOAT_SEL}[data-yq-jivo-lift-bound]`).forEach((node) => {
        delete node.dataset.yqJivoLiftBound;
      });
      findAndBind();
    });
    mo.observe(host, { childList: true });
  }

  let bodyFindObserver;

  function waitForFloatOnce() {
    if (document.querySelector(FLOAT_SEL)) {
      findAndBind();
      if (bodyFindObserver) {
        bodyFindObserver.disconnect();
        bodyFindObserver = null;
      }
      return;
    }
    if (bodyFindObserver) return;
    bodyFindObserver = new MutationObserver(() => {
      if (document.querySelector(FLOAT_SEL)) {
        findAndBind();
        bodyFindObserver.disconnect();
        bodyFindObserver = null;
      }
    });
    bodyFindObserver.observe(document.body, { childList: true, subtree: true });
  }

  let mqBound = false;

  function init() {
    if (!isProductPage()) return;

    findAndBind();
    bindStickyHost(document.querySelector(STICKY_HOST_SEL));
    waitForFloatOnce();

    if (!mqBound) {
      mqBound = true;
      mq.addEventListener('change', () => {
        findAndBind();
      });
    }
  }

  function resetAndInit() {
    document.querySelectorAll(`${FLOAT_SEL}[data-yq-jivo-lift-bound]`).forEach((node) => {
      delete node.dataset.yqJivoLiftBound;
    });
    document.querySelectorAll(`${STICKY_HOST_SEL}[data-yq-jivo-lift-host-bound]`).forEach((node) => {
      delete node.dataset.yqJivoLiftHostBound;
    });
    if (bodyFindObserver) {
      bodyFindObserver.disconnect();
      bodyFindObserver = null;
    }
    init();
  }

  function afterLoad() {
    portalFloatBar();
    syncBodyClass();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Jivo 等脚本可能在 load 后改 DOM，延迟再 portal 一次 */
  window.addEventListener('load', () => {
    afterLoad();
    requestAnimationFrame(() => {
      requestAnimationFrame(afterLoad);
    });
  });

  document.addEventListener('shopify:section:load', resetAndInit);
})();
